import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MySandboxComponent } from 'src/app/main/my-sandbox/my-sandbox.component';
import { Permission } from 'src/app/models/principal/permission';
import { PermissionGuard } from 'src/app/services/util/permission.guard';
import { ToolbarButton } from '../../models/toolbar-button/toolbar-button';

const routes: Routes = [
  {
    path: '',
    component: MySandboxComponent,
    canActivate: [PermissionGuard],
    data: {
      activeLink: ToolbarButton.MY_SANDBOX,
      permissionRule: {
        not: Permission.VIEW_ENTERPRISE
      }
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MySandboxRoutingModule {
}
